import { ModuleDefault } from '../default'
import { IPageParams } from '@dto'

export class Read extends ModuleDefault {
  public getAll(merchantId: string, params: IPageParams = {}): Promise<any> {
    params.page = params.page || 1
    params.size = params.size || 10
    const queryParams = this.utils.paramSerializer(params)
    return this.request.get(
      `${this.setup.urlBase}/merchants/${merchantId}/charges${queryParams}`
    )
  }

  public getById(merchantId: string, chargeId: string) {
    return this.request.get(
      `${this.setup.urlBase}/merchants/${merchantId}/charges/${chargeId}`
    )
  }
}
